import { useCallback } from 'react';
import {
  EmptyView,
  Flex,
  IconEmptyZzim,
  PrimaryButton,
} from '@banhala/ui-kit';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useLogClickCtaButton } from '../hooks/useLogClickCtaButton';

const RANKING_GOODS_DEEPLINK = 'ably://ranking/goods';

/**
 * 찜한 상품이 0건이고 오늘출발 필터도 꺼진 상태일 때 노출되는 빈 화면.
 * iOS `EmptyGuideView.likedGood` / Android `LikeGoodsScreen.GoodsEmptyComponent` 와 동일.
 */
export const LikedGoodsEmpty = () => {
  const { openDeeplink } = useOpenDeeplink();
  const logClickCtaButton = useLogClickCtaButton();

  const handlePress = useCallback(() => {
    logClickCtaButton('RANKING');
    openDeeplink(RANKING_GOODS_DEEPLINK);
  }, [logClickCtaButton, openDeeplink]);

  return (
    <Flex.Center flex={1} padding={{ vertical: 80, horizontal: 12 }} gap={16}>
      <EmptyView
        title={'찜한 상품이 없어요'}
        description={'에이블리의 인기 상품을 보러갈까요?'}
        icon={<IconEmptyZzim />}
      />
      <Flex width={200}>
        <PrimaryButton
          color={'gray'}
          size={'medium'}
          variant={'fill'}
          onPress={handlePress}
        >
          랭킹 상품 보러가기
        </PrimaryButton>
      </Flex>
    </Flex.Center>
  );
};
